import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Ruta/filtrarRuta`, method: 'POST', body: values, token: token})
}
